const portlets = new Map();

export default {
  register(portletId, factoryFunction) {
    if (typeof factoryFunction !== 'function') {
      throw new Error(`Factory for portlet "${portletId}" must be a function.`);
    }

    portlets.set(portletId, factoryFunction);
  },

  make(portletId, ...args) {
    const factoryFunction = portlets.get(portletId);

    if (factoryFunction === undefined) {
      throw new Error(`No factory registered for portlet "${portletId}".`);
    }

    return factoryFunction(...args);
  },
};
